exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bottom_button[data-v-a50c68de]{padding:10px 20px 50px 20px;position:fixed;width:100%;background-color:#fff;-webkit-box-shadow:1px 0 3px #ee0a24;box-shadow:1px 0 3px #ee0a24}", ""]);

// exports
